import { render, staticRenderFns } from "./ConfigurationModal.vue?vue&type=template&id=4771382a&"
import script from "./ConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./ConfigurationModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationModal.vue?vue&type=style&index=0&id=4771382a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports